import { render, staticRenderFns } from "./DeliveryStamp.vue?vue&type=template&id=1d65dceb&scoped=true&"
var script = {}
import style0 from "./DeliveryStamp.vue?vue&type=style&index=0&id=1d65dceb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d65dceb",
  null
  
)

export default component.exports